import React from "react";

import { useIntl } from "react-intl";

import * as Sticker from "ds/Sticker";
import useUrls from "Hooks/useUrls";
import {
  selectFeatureUsageBasedBillingEnabled,
  selectProjectTrafficBlockEnabled
} from "Reducers/featureFlags/featureFlags.selectors";
import { useUrlParamsSubscription } from "Reducers/organization/subscription/hooks";
import { useAppSelector } from "Store/hooks";

import * as S from "./style";

const TrafficInfo = () => {
  const subscription = useUrlParamsSubscription();
  const usageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);
  const intl = useIntl();
  const projectTrafficBlockEnabled = useAppSelector(
    selectProjectTrafficBlockEnabled
  );

  const [usageBasedBillingUrl, projectUrl] = useUrls(
    ["organization.project.usageBasedBilling", "organization.project"],

    { subscriptionId: subscription?.id ?? "" }
  );

  const hasFastly = (subscription?.fastly_service_ids?.length ?? 0) > 0;

  return hasFastly && projectTrafficBlockEnabled ? (
    <S.StickerWrapper>
      <Sticker.Root>
        <Sticker.Icon priority="information" />
        <Sticker.Text>
          <div>
            {intl.formatMessage<React.ReactNode>(
              {
                id: usageBilling
                  ? "cdn_traffic_sticker.billing"
                  : "cdn_traffic_sticker.overview"
              },
              {
                link: chunks => (
                  <a href={usageBilling ? usageBasedBillingUrl : projectUrl}>
                    {chunks}
                  </a>
                )
              }
            )}
          </div>
        </Sticker.Text>
      </Sticker.Root>
    </S.StickerWrapper>
  ) : null;
};

export default TrafficInfo;
